import React, { useCallback } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { AlertIcon } from "../../assets/icons";

const Input = ({
  name = "",
  spacing = false,
  options = {},
  register,
  onSubmit = () => {},
  selectOnFocus = false,
  captchaUrl = null,
  strokeOnError = true,
  fillOnError = true,
  textAlign = "right",
  hidePasswordToggle = false,
  required = false,
  onShowPasswordToggle = () => {},
  forceShowPasswordToggle = false,
  leftIcon = null,
  rightIcon = null,
  hasError = false,
  msg = "",
  label = "",
  className = "",
  isLoginInput = false,
  ...rest
}) => {
  const onShowPasswordMouseDown = useCallback(() => {
    onShowPasswordToggle("down");
  }, [onShowPasswordToggle]);

  const onShowPasswordMouseUp = useCallback(() => {
    onShowPasswordToggle("up");
  }, [onShowPasswordToggle]);

  const onFocus = (event) => {
    if (selectOnFocus === false) return;
    event.target.select();
  };
  const iconColor = hasError
    ? {
        ...(strokeOnError && { stroke: "#FF5E56" }),
        ...(fillOnError && { fill: "#FF5E56" }),
      }
    : {};
  return (
    <div className={className}>
      <div
        className={`outline-1 flex flex-row justify-between relative ${
          { ...rest }.disabled ? isLoginInput? "border" : "bg-highlight" : "border"
        }  rounded-xl ${
          hasError
            ? "border-error"
            : !isLoginInput
            ? "focus-within:border-brand border-accent-negative"
            : "focus-within:border-cyan-300 border-accent-negative"
        }  flex justify-center items-center`}
      >
        {!hidePasswordToggle &&
          ({ ...rest }.type === "password" || forceShowPasswordToggle) && (
            <div
              onTouchStart={onShowPasswordMouseDown}
              onTouchEnd={onShowPasswordMouseUp}
              onMouseDown={onShowPasswordMouseDown}
              onMouseUp={onShowPasswordMouseUp}
              className="pr-4 w-12"
            >
              {{ ...rest }.type === "password" ? (
                <FiEyeOff
                  className={
                    hasError
                      ? "stroke-error"
                      : !isLoginInput
                      ? "stroke-brand"
                      : "!stroke-[#fff]"
                  }
                />
              ) : (
                <FiEye
                  className={
                    hasError
                      ? "stroke-error"
                      : !isLoginInput
                      ? "stroke-brand"
                      : "!stroke-[#fff]"
                  }
                />
              )}
            </div>
          )}
        {rightIcon && (
          <div className="pr-4">
            {React.cloneElement(rightIcon, {
              className: `h-5 ${rightIcon.props.className}`,
              ...iconColor,
            })}
          </div>
        )}
        <div className="flex-1">
          <input
            style={spacing ? { letterSpacing: "1.5rem" } : {}}
            {...register(name, { ...options })}
            onFocus={onFocus}
            onSubmit={onSubmit}
            autoComplete="disabled"
            {...rest}
            {...({ ...rest }.disabled
              ? { disabled: false, readOnly: true }
              : null)}
            className={`h-12 block px-4 w-full appearance-none focus:outline-none bg-transparent rounded-xl ${
              textAlign === "center"
                ? "text-center"
                : textAlign === "left"
                ? "text-left ltr"
                : "text-right rtl"
            } ${isLoginInput ? "text-[#fff] loginInput" : "text-title"}`}
          />
          <label
            className={`${
              hasError ? "text-error" : "text-title"
            } text-sm font-semibold border border-borderSolid absolute top-1 rounded-xl bg-white right-0 pointer-events-none transform pt-1  -z-1 duration-200 origin-0 scale-75 -translate-y-5 z-0 ml-3 px-2 py-1`}
          >
            {label}
            {required && <span className="text-red-600">*</span>}
          </label>
        </div>
        {leftIcon && (
          <div className="pl-4 icon">
            {React.cloneElement(leftIcon, {
              className: `h-5 w-5`,
            })}
          </div>
        )}
        {captchaUrl && (
          <img
            alt="Captcha"
            src={captchaUrl}
            className="w-1/2 h-12 rounded-l-xl border-r border-details"
          />
        )}
      </div>
      {hasError && msg.trim() !== "" && (
        <div
          className={
            "min-h-9 py-2 rounded-lg bg-error-20 text-error font-semibold text-xs flex items-center mt-2 text-right p-1"
          }
        >
          <AlertIcon className="h-6 w-6 ml-1" />
          {msg}
        </div>
      )}
    </div>
  );
};

export default Input;
